import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import StatusuebersichtIcon from '#components/svg/icons/NavStatusUebersicht'
import StyledText from '#components/a/StyledText'
import {routeHelper} from '#config/routeKeys'

export class AbteilungAbschliessenBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick, senderId} = this.props
    onNotificationClick(routeHelper.praxisaufgabenDetail(senderId))
  }

  render() {
    const {userInfo, abteilungName} = this.props
    const text = i18n.t('notification_text_abteilung_abschliessen', [
      `${userInfo.lastname}, ${userInfo.firstname}`,
      abteilungName,
    ])

    return (
      <div
        role="button"
        tabIndex={0}
        className="notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <Avatar profileImage={userInfo.profileImage} />
        <StyledText text={text} modifier="notification" />
        <div className="notification__icon notification__icon--right">
          <StatusuebersichtIcon />
        </div>
      </div>
    )
  }
}

AbteilungAbschliessenBenachrichtigung.propTypes = {
  senderId: PropTypes.number,
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  abteilungName: PropTypes.string.isRequired,
  onNotificationClick: PropTypes.func,
}

export default UserInfoHOC(AbteilungAbschliessenBenachrichtigung, ['senderId'])
